import { Background, Card, Flex } from '@Common/Components'
import { getHost } from '@Common/Services'

export const PageContent = ({ children, noCard, customBackgroundUrl }) => (
  <Background theme={getHost()[0].theme} customBackgroundUrl={customBackgroundUrl}>
    <Flex fh fw js as style={{ padding: 20, overflowX: 'hidden', overflowY: 'scroll' }}>
      {noCard
        ? <Flex fw row> {children}</Flex>
        : (
          <Card style={{ width: '100%' }}>
            <Flex fw>{children}</Flex>
          </Card>)}
    </Flex>
  </Background>
)
